export default __webpack_public_path__ + "static/media/TotemPrototype40.271cc4e4.jpg";